export default __webpack_public_path__ + "static/media/blog art.4f8ed314.PNG";